import { getPlatform } from "@/utils/platform";
import { getMSToken } from "@/utils/url-parse";

/**
 * 获取直播登录接口参数
 * @returns
 */
export function getLiveLoginParam() {
  let liveLoginObj = {};
  const { isWxH5 } = getPlatform();
  if (isWxH5 || !!getMSToken()) {
    liveLoginObj = {
      trusteeshipMode: 20,
      thirdUserToken: getMSToken(),
      loginChannel: 20,
    };
  } else {
    const useInfo = JSON.parse(localStorage.getItem("userinfo") ?? "") ?? {};
    liveLoginObj = {
      trusteeshipMode: 10,
      userId: useInfo.userId,
      loginChannel: 20,
    };
  }
  return liveLoginObj;
}

/**
 * HTTP错误回调
 * @returns
 */
// export function onHttpErrorCallback() {
//   const { isWxH5, isBrowser } = getPlatform();
//   if (isWxH5) {
//     const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
//     // eslint-disable-next-line no-restricted-syntax
//     window.location.href = `/api/member/auth?backUrl=${window.encodeURIComponent(current)}`;
//   } else if (isBrowser) {
//     // store.commit("setIsShowPopupLogin", true);
//   }
// }
